import React, { useState } from 'react';
import { Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const InputFileUpload = ({ image, label, id, handleFiles, disabled, uploadedFile, onDelete }) => {
  const fileInputRef = React.useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  // Create preview URL when uploadedFile changes
  React.useEffect(() => {
    if (uploadedFile) {
      const url = URL.createObjectURL(uploadedFile);
      setPreviewUrl(url);
      
      // Cleanup function to revoke URL
      return () => {
        URL.revokeObjectURL(url);
      };
    } else {
      setPreviewUrl(null);
    }
  }, [uploadedFile]);

  const handleButtonClick = () => {
    if (disabled) return;
    fileInputRef.current.click();
  };

  const handleDragOver = (event) => {
    if (disabled) return;
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    if (disabled) return;
    setIsDragging(false);
  };

  // const handleDrop = (event) => {
  //   if (disabled) return;
  //   event.preventDefault();
  //   setIsDragging(false);

  //   if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
  //     handleFiles(event.dataTransfer.files[0], id);
  //   }
  // };

  const handleDrop = (event) => {
  if (disabled) return;
  event.preventDefault();
  setIsDragging(false);

  const file = event.dataTransfer.files[0];
  if (file) {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      alert('Only JPEG, JPG, and PNG files are allowed.');
      return;
    }

    handleFiles(file, id); // valid file
  }
};


  // const handleFileChange = (event) => {
  //   if (event.target.files[0]) {
  //     handleFiles(event.target.files[0], id);
  //   }
  //   event.target.value = null;
  // };

  const handleFileChange = (event) => {
  const file = event.target.files[0];

  if (file) {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      alert('Only JPEG, JPG, and PNG files are allowed.');
      event.target.value = null; // reset the input
      return;
    }

    handleFiles(file, id); //proceed with the valid file
  }

  event.target.value = null;
};


  const handleDeleteClick = (event) => {
    event.stopPropagation(); // Prevent triggering file upload
    onDelete();
  };

  return (
    <div >
      <div 
        className='fp-container' 
        style={{ 
          border: isDragging ? '2px dashed #007bff' : '2px dashed #cccccc', 
          opacity: disabled ? 0.5 : 1, 
          cursor: disabled ? 'not-allowed' : 'pointer',
          // padding: '20px',
          textAlign: 'center',
          borderRadius: '8px',
          backgroundColor: '#fafafa',
          // width: '250px',
          // height: uploadedFile ? '350px' : '280px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          position: 'relative',
          overflow: 'visible'
        }}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleButtonClick}
      >
        {/* Always show the document type icon and label */}
        <img src={image} style={{width:'60px', height:'40px', marginBottom: '2px', flexShrink: 0}} alt={label}/>
        <p className='file-name' style={{ 
          // margin: '10px 0', 
          fontSize: '14px', 
          flexShrink: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%'
        }}>
          {label}
        </p>
        
        {!uploadedFile ? (
          // Show upload icon when no file is selected
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Button 
              size='small' 
              color='primary' 
              sx={{
                textTransform:'none', 
                bgcolor:'transparent',    
                '&:hover': { color: '#000' }
              }}
            >
              <CloudUploadIcon />
            </Button>
          </div>
        ) : (
          // Show uploaded image preview directly below the cloud icon area
          <div style={{ 
            textAlign: 'center', 
            width: '100%', 
            flex: 1, 
            display: 'flex', 
            flexDirection: 'column',
            overflow: 'hidden'
          }}>
            {/* <p style={{ 
              fontSize: '10px', 
              color: '#4caf50', 
              // margin: '5px 0',
              marginBottom:0,
              flexShrink: 0
            }}>
              ✓ File Selected
            </p> */}
            
            {/* Uploaded Image Preview */}
            {previewUrl && (
              <div style={{ 
                // marginTop: '10px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                {/* Image Container */}
                {/* <div style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  // height: '140px', // Fixed height for image
                  width: '100%',
                  padding: '5px',
                  marginBottom: '10px'
                }}>
                  <img 
                    src={previewUrl} 
                    style={{
                      maxWidth: '100%', 
                      maxHeight: '100%', 
                      width: 'auto',
                      height: 'auto',
                      objectFit: 'contain',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                      backgroundColor: '#fff'
                    }} 
                    alt={`${label} preview`}
                  />
                </div> */}
                
                {/* Filename Container - Always visible */}
                <div style={{
                  width: '90%',
                  minHeight: '25px',
                  padding: '5px',
                  backgroundColor: '#f0f0f0',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                }}>
                  <p style={{ 
                    margin: '0', 
                    fontSize: '10px', 
                    color: '#333',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    lineHeight: '15px',
                    fontWeight: '500'
                  }}>
                    {uploadedFile?.name}
                  </p>
                </div>
              </div>
            )}
            
            {/* Delete button */}
            <Button
              onClick={handleDeleteClick}
              size="small"
              sx={{
                position: 'absolute',
                top: '5px',
                right: '5px',
                minWidth: 'auto',
                padding: '4px',
                color: '#f44336'
              }}
            >
              <DeleteIcon fontSize="small" />
            </Button>
          </div>
        )}
        
        <input
          // accept={(id === 'aadhaar_front' || id === 'aadhaar_back' || id === 'pan') ? 'image/png, image/jpeg' : '*/*'}
          accept="image/png, image/jpeg, image/jpg"
          type="file"
          ref={fileInputRef}
          style={{ display:'none' }}
          onChange={handleFileChange}
          capture="environment"
        />
      </div>
    </div>
  );
};

export default InputFileUpload;